export default "__VITE_ASSET__BmwqpHs0__"